import React, { useState } from 'react';
import palette from '../../lib/styles/palette';
import styled from 'styled-components';

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 999;
`;

const Screen = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 100%;
  z-index: -1;
`;

const Modal = styled.div`
  width: 370px;
  border-radius: 4px;
  height: fit-content;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.01);
  background-color: #fff;
  text-align: center;
`;

const ModalText = styled.div`
  width: 100%;
  height: fit-content;
  padding: 25px 25px 15px 25px;
  height: 70px;
  font-size: 1rem;
  text-align: left;
  word-break: keep-all;
`;

const ModalBtnBox = styled.div`
  display: flex;
  padding: 0 15px;
  margin-bottom: 15px;
  justify-content: flex-end;
  font-size: 1rem;
  margin-top: 20px;

  & button {
    cursor: pointer;
    padding: 4px 12px;
    text-align: center;
    border: none;
    font-size: .95rem;
    color: #fff;
    border-radius: 3px;
    background-color: ${palette.webGray[5]};

    &:focus{
      outline: none;
    }     
    
    &.confirm {
      background-color: ${palette.webCyan[5]};
      margin-right: 10px;
    }
  }
`;
const ConfirmInput = styled.input`
    width: 85%;
    padding: 10px 10px;
    border: 1px solid ${palette.webGray[16]};
    border-radius: .2rem;

    &:focus {
        outline: none;
    }
`;

const DateControlAskModal = ({
    text,
    onClick,
    setModal,
    modal,
    confirmText,
}) => {
    const [confirm, setConfirm] = useState("");

    const onControl = () => {
        if(confirm === "일괄 연장") {
            onClick();
            setConfirm("");
            setModal(false);
        } else {
            alert("올바른 연장 문구를 입력해주세요.");
        }
    }

    return(
        <>
            { modal ?
                  <Background >
                    <Screen onClick={() => {
                                setModal(false)
                                setConfirm("");
                        }} />
                    <Modal>
                        <ModalText>{text}</ModalText>
                        <ModalText style={{paddingTop: '10px'}}>기간 연장 시 취소가 불가능합니다.<br/>기간 연장하려면 '일괄 연장'을 입력해주세요.</ModalText>
                        <ConfirmInput onChange={(e)=>{setConfirm(e.target.value)}} value={confirm}/>
                        <ModalBtnBox>
                            <button className="confirm" onClick={() => {onControl()}}>{confirmText}</button>
                            <button onClick={() => {
                                setModal(false)
                                setConfirm("");
                            }}>취소</button>
                        </ModalBtnBox>
                    </Modal>
                  </Background>
                :
                    ""
            }
        </>
    )
}

export default DateControlAskModal;